import './EducationDocumentsPage.css';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import { Link } from 'react-router-dom';

const documents = [
  {
    title:
      'Акт проверки министерством образования и науки Самарской обалсти Самарского областного отделения Общероссийской общественной организации .pdf',
    fileName: 'act-proverki-minobrnauki-soo-vdpo.pdf',
  },
  {
    title:
      'АКТ самообследования Учебного отдела Самарскогообластного отделения ВДПО за 2018 год.pdf',
    fileName:
      'АКТ самообследования Учебного отдела Самарскогообластного отделения ВДПО за 2018 год.pdf',
  },
  {
    title: 'Лицензия на осуществление образовательной деятельности.pdf',
    fileName: 'Лицензия на осуществление образовательной деятельности.pdf',
  },
  {
    title:
      'Отчет об исполнениипредписанияот 23.08.2019 г. N 374-пв-19 (з) об устранении нарушений.pdf',
    fileName:
      'Отчет об исполнениипредписанияот 23.08.2019 г. N 374-пв-19 (з) об устранении нарушений.pdf',
  },
  {
    title:
      'Отчет об исполнениипредписанияN 374-пв-19(л) Об устранении выявленныхнарушений лицензионных требований.pdf',
    fileName:
      'Отчет об исполнениипредписанияN 374-пв-19(л) Об устранении выявленныхнарушений лицензионных требований.pdf',
  },
  {
    title: 'План финансово-хозяйственной деятельности учебного отдела ВДПО.pdf',
    fileName:
      'План финансово-хозяйственной деятельности учебного отдела ВДПО.pdf',
  },
  {
    title: 'Предписание об устранении нарушений от 23.08.2019 г. N 374-пв-19 (з).pdf',
    fileName:
      'Предписание об устранении нарушений от 23.08.2019 г. N 374-пв-19 (з).pdf',
  },
  {
    title:
      'Предписание N 374-пв-19 (л) Об устранении выявленныхнарушений лицензионных требований.pdf',
    fileName:
      'Предписание N 374-пв-19 (л) Об устранении выявленныхнарушений лицензионных требований.pdf',
  },
  {
    title:
      'Приказ об утверждении Положения в порядке и основании перевода, отчисления и восстановление обучающихся в Самарском областном отделении ВДПО.pdf',
    fileName: 'prikaz-perevod-otchislenie-vosstanovlenie.pdf',
  },
  {
    title:
      'Приказ об утверждении Положения о режиме занятий обучающихся в Учебном отделе Самарского областного отделения ВДПО.pdf',
    fileName:
      'Приказ об утверждении Положения о режиме занятий обучающихся в Учебном отделе Самарского областного отделения ВДПО.pdf',
  },
  {
    title:
      'Приказ об утверждении Положения о формах, периодичности и порядке текущего контроля успеваемости и промежуточной аттестации обучающих я в Учебном отделе Самарского областного отделения ВДПО.pdf',
    fileName: 'prikaz-kontrol-uspevaemosti-prom-attestaciya.pdf',
  },
  {
    title:
      'Приказ об утверждении Порядка оформления возникновения, приостановления, изменения и прекращения отношений между Самарским областным отделением ВДПО и обучающимися.pdf',
    fileName: 'prikaz-oformlenie-obrazovatelnyh-otnosheniy.pdf',
  },
  {
    title:
      'Приказ об утвержденииПеречня платных образовательных услуг по обучению пожарно-техническому минимуму.pdf',
    fileName:
      'Приказ об утвержденииПеречня платных образовательных услуг по обучению пожарно-техническому минимуму.pdf',
  },
  {
    title:
      'Приказ об утвержденииПоложения о приеме на обучение в Самарское областное отделение ВДПО.pdf',
    fileName:
      'Приказ об утвержденииПоложения о приеме на обучение в Самарское областное отделение ВДПО.pdf',
  },
  {
    title:
      'Приказ об утвержденииПоложения о самообследовании Самарского областного отделения ВДПО.pdf',
    fileName:
      'Приказ об утвержденииПоложения о самообследовании Самарского областного отделения ВДПО.pdf',
  },
  {
    title:
      'Приказ об утвержденииПравил внутреннего распорядка для обучающихся в Учебном отделе Самарского областного отделения ВДПО.pdf',
    fileName:
      'Приказ об утвержденииПравил внутреннего распорядка для обучающихся в Учебном отделе Самарского областного отделения ВДПО.pdf',
  },
  {
    title:
      'Приказ об утвержденииТиповой формы договора на оказание платных образовательных услуг.pdf',
    fileName:
      'Приказ об утвержденииТиповой формы договора на оказание платных образовательных услуг.pdf',
  },
  {
    title: 'Санитарно-эпидемиологическое заключение.pdf',
    fileName: 'Санитарно-эпидемиологическое заключение.pdf',
  },
  {
    title: 'Устав ВДПО 23.03.2021.pdf',
    fileName: 'Устав ВДПО 23.03.2021.pdf',
  },
  {
    title: 'Экспертное заключение.pdf',
    fileName: 'Экспертное заключение.pdf',
  },
];

function EducationDocumentsPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="educationDocumentsPage">
          <div className="educationDocumentsPage__breadcrumbs">
            <Link
              to="/education/"
              className="educationDocumentsPage__breadcrumbs-link"
            >
              Образование
            </Link>
            <span className="educationDocumentsPage__breadcrumbs-separator">
              /
            </span>
            <span className="educationDocumentsPage__breadcrumbs-current">
              Документы
            </span>
          </div>

          <div className="educationDocumentsPage__hero">
            <h2 className="educationDocumentsPage__title">Документы</h2>
            <p className="educationDocumentsPage__lead">
              В разделе размещены документы связанные с образовательной
              деятельностью Самарского областного отделения ВДПО.
            </p>
          </div>

          <div className="educationDocumentsPage__list">
            {documents.map(({ title, fileName }, index) => (
              <article className="educationDocumentsPage__card" key={fileName}>
                <div className="educationDocumentsPage__card-content">
                  <p className="educationDocumentsPage__card-number">
                    Документ {index + 1}
                  </p>
                  <h3 className="educationDocumentsPage__card-title">
                    {title.replace(/\.pdf$/i, '').trim()}
                  </h3>
                </div>
                <a
                  href={`/images/vdpo_educational/Документы/${encodeURIComponent(fileName)}`}
                  className="educationDocumentsPage__card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Открыть PDF
                </a>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default EducationDocumentsPage;
